import React, { Component } from 'react';
import { isEmpty } from "lodash";
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Edit, CloudDownloadRounded, AddCircleRounded } from '@mui/icons-material';
import { IconButton, Grid, Box } from '@mui/material';
import ChantierSingle from './ChantierSingle';
import SearchBar from '../../common/SearchBar';
import AddSpending from './AddSpending';


// const tmpPaygoList = {

//     "azaaa": {boxAssoId: "azaaa", paygoID: "PAYG1", clientName: "fefe"},
//     "4DASVBA": {boxAssoId: "4DASVBA", paygoID: "PAYG2", clientName: "toto"},
//     "FATGSV7": {boxAssoId: "FATGSV7", paygoID: "PAYG3", clientName: "tata"},
//     "ANSAO9O": {boxAssoId: "ANSAO9O", paygoID: "PAYG4", clientName: "fifi"},
//     "GVAS6U": {boxAssoId: "GVAS6U", paygoID: "PAYG5", clientName: "lili"},
//     "568780HN": {boxAssoId: "568780HN", paygoID: "PAYG6", clientName: "bob"},
// }

class ChantiersList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 10,
        openForm: false,
        openUpdate: false,
        openDetails: false,
        openAddSpending: false,
        selected: {},
        selectedChantier: {},
        searchValue: "",
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        if(isEmpty(this.props.CHANTIERS)){
            this.props.fetchChantiers()
        }
        // if(isEmpty(this.props.TIMESHEET)){
        //     this.props.fetchTimesheets()
        // }
    }

    handleClose = () => {
		this.setState({ 
            openForm: false,
            openUpdate: false,
            openDetails: false,
            openAddSpending: false,
            selected: {},
            selectedChantier: {},
        });
    };    

    getChantiersList = () => {
        const { searchValue } = this.state;
        // const { rowsPerPage, page, searchValue } = this.state;
        const { CHANTIERS } = this.props;
        if (!isEmpty(CHANTIERS)){
            let list = Object.values(CHANTIERS)
            if( !isEmpty(searchValue) ){
                list = list.filter( chantier => chantier.chantier_name.toLowerCase().includes(searchValue) );
            }

            // return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item =>
            return list.map(item => (
                <TableRow hover key={item.boxAssoId} className="">
                    <TableCell
                        onClick={ () => this.setState({ openDetails: true, selectedChantier: item})}
                    >
                        {item && item.paygoID}
                    </TableCell>                                                   
                    <TableCell
                        onClick={ () => this.setState({ openDetails: true, selectedChantier: item})}
                    >
                        {item && item.chantier_name}
                    </TableCell>                                                   
                    {/* <TableCell
                        onClick={ () => this.setState({ openDetails: true, selectedChantier: item})}
                    >
                        {new Date(item.chantier_start_date).toLocaleDateString("fr-FR")}    
                    </TableCell>                                                  
                    <TableCell
                        onClick={ () => this.setState({ openDetails: true, selectedChantier: item})}
                    >
                        {item.chantier_desc}
                    </TableCell>  */}
                    {/* <TableCell>                        
                        {this.props.isAdmin && !this.props.isUserPlus &&
                            <IconButton 
                                title="Ajouter" 
                                color="primary"
                                onClick={ () => this.setState({ openAddSpending: true, selected: item}) }
                            >
                                <AddCircleRounded />
                            </IconButton>  
                        }
                    </TableCell>  */}
                </TableRow>
            ) )
        }
    }

    handleChange = (e) => {
        const { value } = e.target;

        this.setState({
            "searchValue": value.toLowerCase()
        })
    }

    render() {
        const { openForm, openUpdate, selected, openDetails, selectedChantier, openAddSpending } = this.state;
        return (
            <div>
                
                {openDetails && !isEmpty(selectedChantier) &&
                    <ChantierSingle
                        open={openDetails} 
                        chantier={selectedChantier}
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
                {/* {openAddSpending && !isEmpty(selected) &&
                    <AddSpending
                        open={openAddSpending} 
                        chantier={selected}
                        chantier_name={selected.clientName}
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                } */}
              
                <Typography variant="h6" id="tableTitle">
                    Liste des Chantiers
                </Typography>

                <Box style={{ display:"flex", justifyContent:"space-between", alignItems: "center"}}>
                    <SearchBar 
                        handleChange={this.handleChange} 
                        label="Chantier"
                        searchValue={this.state.searchValue}
                    />
                    
                    {/* <Button 
                        variant="contained" 
                        color="secondary" 
                        onClick={() => this.setState({ openForm: true })} title="Nouveau Chantier"
                        startIcon={
                            <AddCircleIcon />
                        }
                    >
                        Ajouter
                    </Button> */}
                        {/* <IconButton color="primary" onClick={ () => this.props.handleDownload("/extract/chantiers", "MJB_chantiers.csv") } disabled={this.props.downloading}>
                            <CloudDownloadRounded />
                        </IconButton> */}
                </Box>

                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Paygo ID</TableCell>
                            <TableCell>Nom</TableCell>
                            {/* <TableCell>Démarrage</TableCell>
                            <TableCell>Description</TableCell> */}
                            {/* <TableCell>Modifier {this.props.isAdmin && !this.props.isUserPlus && "/ Ajouter Dépenses"}</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.getChantiersList()}
                    </TableBody>
                    {/* {size(CHANTIERS) > 10 &&
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[10, 15]}
                                    colSpan={2}
                                    count={size(CHANTIERS)}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    onPageChange={this.handleChangePage}
                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                    ActionsComponent={Pagination}
                                />
                            </TableRow>
                        </TableFooter>
                    } */}
                </Table> 
            </div>
        );
    }
}

export default ChantiersList;